/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
/* eslint-disable new-cap */
/* eslint-disable no-await-in-loop */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { get } from 'lodash';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import JsBarcode from 'jsbarcode';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

import axios from '../../services/axios';
import Loading from '../../components/Loading';
import CurrencyInput from '../../components/MinorUtilities/CurrencyInput';
import {
   parseCurrencyToDecimal,
   formatDecimalToCurrency,
} from '../../components/utils/formatCurrency';

import Modal from '../../components/Modal/Modal';

import { Container } from '../../styles/layout/Container';

import {
   PageHeader,
   PageHeaderActions,
   PageHeaderText,
   PageSubtitle,
   PageTitle,
} from '../../styles/layout/PageHeader';

import {
   Section,
   SectionBody,
   SectionHeader,
   SectionTitle,
} from '../../styles/layout/Section';

import { FormGrid } from '../../styles/layout/FormGrid';
import { ActionBar } from '../../styles/layout/ActionBar';
import { Field } from '../../styles/forms/Field';

import { EmptyState } from '../../styles/feedback/EmptyState';

import ProductAudit from '../../components/ProductAudit';

const integerRegex = /^[0-9]+$/;

const InputWithUnit = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;

   > input {
      flex: 1;
      min-width: 0;
      text-align: right;
   }

   > span {
      white-space: nowrap;
      opacity: 0.8;
      font-size: 0.9em;
   }
`;

const HelpText = styled.p`
   margin: 0;
   opacity: 0.8;
   font-size: 0.95em;
   line-height: 1.3;
`;

const LabelPreviewCard = styled.div`
   width: 100%;
   max-width: 420px;
   border: 1px dashed rgba(0, 0, 0, 0.25);
   border-radius: 10px;
   padding: 12px 14px;
   display: flex;
   flex-direction: column;
   gap: 8px;
   background: #fff;

   .label-top,
   .label-bottom {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      font-weight: 600;
      gap: 8px;
   }

   .label-middle {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 6px 0;
   }

   .barcode {
      width: 100%;
   }

   .barcode svg {
      width: 100%;
      height: 62px;
   }

   .product-sku {
      font-size: 11px;
      font-weight: 600;
   }

   .product-name {
      font-size: 13px;
      font-weight: 800;
      text-align: center;
   }
`;

export default function ProductEdit() {
   // product parameters
   const { id } = useParams();

   const navigate = useNavigate();
   const isCreateMode = !id;

   // evita loop/chamadas repetidas no blur do SKU
   const skuCheckRef = useRef({ lastSku: '', inFlight: false });

   const getEmptyProduct = () => ({
      prod_sku: '',
      prod_name: '',
      sku: '',
      name: '',
      prod_status: 1,
      category: { id: '', name: '' }, // ✅ Evita undefined
      brand: { id: '', name: '' }, // ✅ Evita undefined
      stock: { min_quantity: '' }, // ✅ Evita undefined
      dimensions: { height: '', width: '', length: '' }, // ✅ Evita undefined
      pricing: { cost_price: formatDecimalToCurrency(0) }, // ✅ Evita undefined
      weight: '',
      volumetry: null,
      // Mantém flat para o envio ao backend
      category_id: '',
      brand_id: '',
      min_stock_qtd: '',
      cost_price: formatDecimalToCurrency(0),
      prod_height: '',
      prod_width: '',
      prod_length: '',
      prod_weight: '',
   });

   const resetToCreate = () => {
      const empty = getEmptyProduct();
      setParamList(empty);
      setNewParamList(empty);
      setEditOn(true);
      skuCheckRef.current.lastSku = '';
   };

   const [categories, setCategories] = useState([]);
   const [brands, setBrands] = useState([]);

   // parameters list goes here
   // eslint-disable-next-line no-unused-vars
   const [paramList, setParamList] = useState(getEmptyProduct);
   const [newParamList, setNewParamList] = useState(getEmptyProduct);
   const [barcodeMarkup, setBarcodeMarkup] = useState('');

   const [isLoading, setIsLoading] = useState(false);

   // switches Edit/Save mode
   const [editOn, setEditOn] = useState(isCreateMode);

   // Controle de modals
   const [isLabelsModalOpen, setIsLabelsModalOpen] = useState(false);
   const [isAuditModalOpen, setIsAuditModalOpen] = useState(false);

   // label parameters
   const defaultCompanyName = 'MYSHOP COMERCIO E SERVICOS LTDA';
   const defaultCompanyCnpj = '11.156.936/0001-22';
   const [labelQty, setLabelQty] = useState(1);
   const [entryDate, setEntryDate] = useState('');
   const [entryDoc, setEntryDoc] = useState('');
   const [companyName] = useState(defaultCompanyName);
   const [companyCnpj] = useState(defaultCompanyCnpj);

   // barcode ref (hidden svg used to generate markup even with modal closed)

   const LABEL_WIDTH_MM = 100; // 10 cm (largura total da etiqueta)
   const LABEL_HEIGHT_MM = 50; // 5 cm (altura total da etiqueta)

   const LABEL_STYLES = `
    @page {
      size: ${LABEL_WIDTH_MM}mm ${LABEL_HEIGHT_MM}mm;
      margin: 5mm 5mm 0 5mm;
    }

    * { box-sizing: border-box; }

    html, body {
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
    }

    body {
      display: flex;
      flex-direction: column;
      color: #000;
      font-family: Arial, sans-serif;
    }

    .label {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 0;
      gap: 1.5mm;
    }

    .label + .label {
      page-break-before: always;
    }

    .label-top, .label-bottom {
      display: flex;
      justify-content: space-between;
      font-size: 10px;
      font-weight: 300;
      flex: 0 0 20%;
    }

    .label-middle {
      flex: 0 0 60%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 6px;
    }

    .barcode svg {
      width: 100%;
      height: 64px;
    }

    .product-sku {
      font-size: 10px;
      font-weight: 600;
    }

    .product-name {
      font-size: 12px;
      text-align: center;
      font-weight: 700;
    }
  `;

   const [refreshKey, setRefreshKey] = useState(0);

   useEffect(() => {
      const fetchProductData = async () => {
         setIsLoading(true);
         try {
            const [categoriesRes, brandsRes] = await Promise.all([
               axios.get('/prodcategories'),
               axios.get('/prodbrands'),
            ]);

            setCategories(categoriesRes.data);
            setBrands(brandsRes.data);

            if (isCreateMode) {
               const empty = getEmptyProduct();
               setParamList(empty);
               setNewParamList(empty);
               setEditOn(true);
            } else {
               const {
                  data: {
                     data: { product },
                  },
               } = await axios.get(`/products/${id}`);
               handleAddParams(product);
               setEditOn(false);
            }
         } catch (err) {
            toast.info(err);
            // eslint-disable-next-line no-console
            console.log(err);
         }
         setIsLoading(false);
      };

      fetchProductData();
   }, [id, refreshKey, isCreateMode]);

   const handleEnableEdit = () => {
      setEditOn(true);
   };

   const handleDisableEdit = () => {
      setNewParamList(paramList);
      setEditOn(false);
   };

   const handleAddParams = (data) => {
      const formatted = {
         ...data,
         prod_sku: data.sku,
         prod_name: data.name,
         category_id: data.category.id,
         brand_id: data.brand.id,
         min_stock_qtd: data.stock.min_quantity,
         prod_height: data.dimensions.height,
         prod_width: data.dimensions.width,
         prod_length: data.dimensions.length,
         prod_weight: data.weight,
         cost_price: formatDecimalToCurrency(
            parseFloat(data.pricing.cost_price ?? 0)
         ),
      };
      setParamList(formatted);
      setNewParamList(formatted);
   };

   const handleChangeParams = (e) => {
      const { name, value } = e.target;

      setNewParamList((prevParams) => ({
         ...prevParams,
         [name]: value,
      }));
   };

   const handleChangeCurrency = (name, value) => {
      setNewParamList((prevParams) => ({
         ...prevParams,
         [name]: value,
      }));
   };

   const buildBarcodeValue = (sku) => {
      const digits = String(sku ?? '').replace(/\D/g, '');
      if (!digits) return '0000000';
      const trimmed = digits.slice(0, 7);
      return trimmed.padEnd(7, '0');
   };

   useEffect(() => {
      const sku = newParamList.prod_sku;
      if (!sku) {
         setBarcodeMarkup('');
         return;
      }

      const value = buildBarcodeValue(sku);

      try {
         const svg = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'svg'
         );

         JsBarcode(svg, value, {
            format: 'CODE128',
            displayValue: false,
            margin: 0,
            width: 1.6,
            height: 60,
         });

         const serialized = new XMLSerializer().serializeToString(svg);
         setBarcodeMarkup(serialized);
      } catch (error) {
         console.error('Erro ao gerar código de barras', error);
         toast.error('Não foi possível gerar o código de barras para o SKU.');
         setBarcodeMarkup('');
      }
   }, [newParamList.prod_sku]);

   const renderLabelHtml = (qty) =>
      Array.from({ length: qty })
         .map(
            (_item, index) => `
          <div class="label">
            <div class="label-top">
              <span>Dt. Ent.: ${entryDate || '--/--/----'}</span>
              <span>${index + 1} de ${qty}</span>
              <span>Doc. Ent.: ${entryDoc || ''}</span>
            </div>
            <div class="label-middle">
              <div class="barcode">${barcodeMarkup}</div>
              <div class="product-sku">SKU: ${buildBarcodeValue(newParamList.prod_sku)}</div>
              <div class="product-name">${newParamList.prod_name || ''}</div>
            </div>
            <div class="label-bottom">
              <span>${companyName || ''}</span>
              <span>${companyCnpj || ''}</span>
            </div>
          </div>
        `
         )
         .join('');

   const downloadLabelsPdf = async (labelHtml) => {
      const wrapper = document.createElement('div');
      wrapper.style.position = 'fixed';
      wrapper.style.left = '-9999px';
      wrapper.style.top = '-9999px';
      wrapper.style.width = `${LABEL_WIDTH_MM}mm`;
      wrapper.style.height = `${LABEL_HEIGHT_MM}mm`;
      wrapper.innerHTML = `<style>${LABEL_STYLES}</style>${labelHtml}`;
      document.body.appendChild(wrapper);

      const pdf = new jsPDF({
         orientation: 'landscape',
         unit: 'mm',
         format: [LABEL_HEIGHT_MM, LABEL_WIDTH_MM],
      });

      const MARGIN_LEFT = 4;
      const MARGIN_RIGHT = 4;
      const MARGIN_TOP = 4;
      const MARGIN_BOTTOM = 4;

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const printableWidth = pageWidth - MARGIN_LEFT - MARGIN_RIGHT;
      const printableHeight = pageHeight - MARGIN_TOP - MARGIN_BOTTOM;

      const labels = wrapper.querySelectorAll('.label');

      for (let i = 0; i < labels.length; i += 1) {
         const canvas = await html2canvas(labels[i], { scale: 3 });
         const img = canvas.toDataURL('image/png');

         if (i > 0) {
            pdf.addPage([LABEL_HEIGHT_MM, LABEL_WIDTH_MM], 'landscape');
         }

         pdf.addImage(
            img,
            'PNG',
            MARGIN_LEFT,
            MARGIN_TOP,
            printableWidth,
            printableHeight
         );
      }

      pdf.save('etiquetas.pdf');
      document.body.removeChild(wrapper);
   };

   const handleSubmitForm = async (e) => {
      e.preventDefault();

      // ✅ Bloqueia se nada mudou
      if (!hasChanges) {
         toast.warn('Nenhuma alteração foi feita.');
         setEditOn(false);
         return;
      }

      try {
         setIsLoading(true);

         const formattedData = {
            prod_name: newParamList.prod_name,
            prod_sku: Number(newParamList.prod_sku),
            prod_status: 'active',
            category_id: newParamList.category_id
               ? Number(newParamList.category_id)
               : null,
            brand_id: newParamList.brand_id
               ? Number(newParamList.brand_id)
               : null,
            min_stock_qtd: newParamList.min_stock_qtd
               ? Number(newParamList.min_stock_qtd)
               : 0,
            cost_price: parseCurrencyToDecimal(newParamList.cost_price),
            prod_height: newParamList.prod_height
               ? Number(newParamList.prod_height)
               : null,
            prod_width: newParamList.prod_width
               ? Number(newParamList.prod_width)
               : null,
            prod_length: newParamList.prod_length
               ? Number(newParamList.prod_length)
               : null,
            prod_weight: newParamList.prod_weight
               ? Number(newParamList.prod_weight)
               : null,
         };

         if (isCreateMode) {
            const response = await axios.post('/products', formattedData);
            const newId = response?.data?.data?.product?.id;
            toast.success(
               newId
                  ? `Produto cadastrado com sucesso (ID: ${newId}).`
                  : 'Produto cadastrado com sucesso.'
            );

            setIsLoading(false);

            if (newId) navigate(`/products/${newId}`);
            return;
         }

         const response = await axios.put(`/products/${id}`, formattedData);
         setRefreshKey((k) => k + 1);
         toast.success(response.data.message);

         setIsLoading(false);
         handleDisableEdit();
      } catch (err) {
         setIsLoading(false);
         const errors = get(err, 'response.data.errors', []);

         if (errors.length) {
            errors.forEach((error) => {
               toast.error(typeof error === 'string' ? error : error.message);
            });
         } else {
            // Fallback para erros sem estrutura (ex: network error)
            toast.error(
               err?.response?.data?.message ||
                  err?.message ||
                  'Erro ao salvar produto.'
            );
         }
      }
   };

   const handleSkuBlur = async () => {
      if (!isCreateMode) return;

      const digits = String(newParamList.prod_sku || '').replace(/\D/g, '');
      if (digits.length < 7) return;

      const sku = digits.slice(0, 7);

      if (skuCheckRef.current.inFlight) return;
      if (skuCheckRef.current.lastSku === sku) return;

      skuCheckRef.current.inFlight = true;
      skuCheckRef.current.lastSku = sku;

      try {
         const resp = await axios.get(`/products/search/${sku}`);
         const foundId = resp?.data?.id;

         if (foundId) {
            // eslint-disable-next-line no-alert
            const go = window.confirm(
               'Esse produto já existe no sistema. Gostaria de visualizá-lo?'
            );

            if (go) {
               navigate(`/products/${foundId}`);
            } else {
               resetToCreate();
            }
         }
      } catch (err) {
         // quando não existe, seu backend responde 400 com errors — aqui a gente só ignora.
      } finally {
         skuCheckRef.current.inFlight = false;
      }
   };

   const handlePrintLabels = async () => {
      const qty = Number(labelQty) || 0;

      if (qty < 1) {
         toast.error('Informe uma quantidade válida de etiquetas.');
         return;
      }

      if (!barcodeMarkup) {
         toast.error('Código de barras não disponível para impressão.');
         return;
      }

      const labelHtml = renderLabelHtml(qty);

      try {
         await downloadLabelsPdf(labelHtml);
      } catch (error) {
         toast.error('Não foi possível gerar o PDF da etiqueta.');
         // eslint-disable-next-line no-console
         console.error('Erro ao gerar PDF das etiquetas', error);
      }
   };

   // Adicionar junto aos outros useMemo
   const hasChanges = useMemo(() => {
      if (isCreateMode) return true; // No create, sempre permite salvar

      // Compara os campos editáveis entre paramList e newParamList
      const fields = [
         'prod_name',
         'category_id',
         'brand_id',
         'min_stock_qtd',
         'cost_price',
         'prod_height',
         'prod_width',
         'prod_length',
         'prod_weight',
         'prod_status',
      ];

      return fields.some(
         (field) =>
            String(paramList[field] ?? '') !== String(newParamList[field] ?? '')
      );
   }, [isCreateMode, paramList, newParamList]);

   const volumetryValue = useMemo(() => {
      const v = newParamList.dimensions.volumetry;
      if (v === null || v === undefined || v === '') return '';
      const num = Number(v);
      if (Number.isFinite(num)) return num.toFixed(3); // m³ (ex: 0.008)
      return String(v);
   }, [newParamList.dimensions.volumetry]);

   const headerSubtitle = useMemo(() => {
      if (isCreateMode) return 'Cadastro';

      const sku = newParamList.prod_sku ? `SKU: ${newParamList.prod_sku}` : '';
      const pid = id ? `ID: ${id}` : '';
      const mode = editOn ? '• Modo edição' : '• Visualização';

      return `${[sku, pid].filter(Boolean).join(' • ')} ${mode}`;
   }, [isCreateMode, newParamList.prod_sku, id, editOn]);

   return (
      <Container>
         <Loading isLoading={isLoading} />

         <PageHeader>
            <PageHeaderText>
               <PageTitle>Produto</PageTitle>
               <PageSubtitle>{headerSubtitle}</PageSubtitle>
            </PageHeaderText>

            <PageHeaderActions>
               {!isCreateMode && (
                  <button type="button" onClick={() => navigate('/product')}>
                     Novo produto
                  </button>
               )}

               {isCreateMode ? (
                  <>
                     <button type="button" onClick={resetToCreate}>
                        Limpar
                     </button>
                     <button type="submit" form="product-edit-form">
                        Cadastrar
                     </button>
                  </>
               ) : !editOn ? (
                  <>
                     <button type="button" onClick={handleEnableEdit}>
                        Editar
                     </button>
                     <button
                        type="button"
                        onClick={() => setIsAuditModalOpen(true)}
                        style={{
                           background: '#673ab7',
                           marginRight: '8px',
                        }}
                     >
                        📊 Ver histórico
                     </button>
                  </>
               ) : (
                  <>
                     <button type="button" onClick={handleDisableEdit}>
                        Cancelar
                     </button>
                     <button type="submit" form="product-edit-form">
                        Salvar
                     </button>
                  </>
               )}
            </PageHeaderActions>
         </PageHeader>

         <form id="product-edit-form" onSubmit={handleSubmitForm}>
            <Section>
               <SectionHeader>
                  <SectionTitle>Identificadores</SectionTitle>
               </SectionHeader>
               <SectionBody>
                  <FormGrid $cols={12}>
                     <Field $col={2} $colMobile={12}>
                        <label>ID</label>
                        <input
                           type="text"
                           disabled
                           value={id || ''}
                           name="id"
                        />
                     </Field>

                     <Field $col={2} $colMobile={12}>
                        <label>SKU</label>
                        <input
                           type="text"
                           name="prod_sku"
                           value={newParamList.prod_sku || ''}
                           maxLength={9}
                           disabled={!editOn || !isCreateMode}
                           onBlur={handleSkuBlur}
                           onChange={(e) => {
                              if (
                                 integerRegex.test(e.target.value) ||
                                 e.target.value === ''
                              ) {
                                 handleChangeParams(e);
                              }
                           }}
                        />
                     </Field>

                     <Field $col={8} $colMobile={12}>
                        <label>Nome</label>
                        <input
                           type="text"
                           name="prod_name"
                           value={newParamList.prod_name || ''}
                           disabled={!editOn}
                           onChange={handleChangeParams}
                        />
                     </Field>

                     <Field $col={6} $colMobile={12}>
                        <label>Categoria</label>
                        <select
                           name="category_id"
                           value={newParamList.category_id || ''}
                           disabled={!editOn}
                           onChange={handleChangeParams}
                        >
                           <option value="">Selecione a categoria</option>
                           {categories.map((category) => (
                              <option
                                 key={String(category.id)}
                                 value={category.id}
                              >
                                 {category.name}
                              </option>
                           ))}
                        </select>
                     </Field>

                     <Field $col={6} $colMobile={12}>
                        <label>Marca</label>
                        <select
                           name="brand_id"
                           value={newParamList.brand_id || ''}
                           disabled={!editOn}
                           onChange={handleChangeParams}
                        >
                           <option value="">Selecione a marca</option>
                           {brands.map((brand) => (
                              <option key={String(brand.id)} value={brand.id}>
                                 {brand.name}
                              </option>
                           ))}
                        </select>
                     </Field>
                  </FormGrid>
               </SectionBody>
            </Section>

            <Section>
               <SectionHeader>
                  <SectionTitle>Estoque e custos</SectionTitle>
               </SectionHeader>
               <SectionBody>
                  <FormGrid $cols={12}>
                     <Field $col={4} $colMobile={12}>
                        <label>Estoque mínimo</label>
                        <input
                           type="text"
                           name="min_stock_qtd"
                           value={newParamList.min_stock_qtd || 0}
                           disabled={!editOn}
                           onChange={(e) => {
                              if (
                                 integerRegex.test(e.target.value) ||
                                 e.target.value === ''
                              ) {
                                 handleChangeParams(e);
                              }
                           }}
                        />
                     </Field>

                     <Field $col={4} $colMobile={12}>
                        <label>Preço de custo</label>
                        <CurrencyInput
                           value={newParamList.cost_price || '0.00'}
                           onChange={(value) =>
                              handleChangeCurrency('cost_price', value)
                           }
                           disabled={!editOn}
                        />
                     </Field>
                  </FormGrid>
               </SectionBody>
            </Section>

            <Section>
               <SectionHeader>
                  <SectionTitle>Dimensões da embalagem</SectionTitle>
               </SectionHeader>
               <SectionBody>
                  <FormGrid $cols={12}>
                     <Field $col={2} $colMobile={12}>
                        <label>Altura</label>
                        <InputWithUnit>
                           <input
                              type="text"
                              name="prod_height"
                              value={newParamList.prod_height || 0}
                              disabled={!editOn}
                              onChange={(e) => {
                                 if (
                                    integerRegex.test(e.target.value) ||
                                    e.target.value === ''
                                 ) {
                                    handleChangeParams(e);
                                 }
                              }}
                           />
                           <span>cm</span>
                        </InputWithUnit>
                     </Field>

                     <Field $col={2} $colMobile={12}>
                        <label>Largura</label>
                        <InputWithUnit>
                           <input
                              type="text"
                              name="prod_width"
                              value={newParamList.prod_width || 0}
                              disabled={!editOn}
                              onChange={(e) => {
                                 if (
                                    integerRegex.test(e.target.value) ||
                                    e.target.value === ''
                                 ) {
                                    handleChangeParams(e);
                                 }
                              }}
                           />
                           <span>cm</span>
                        </InputWithUnit>
                     </Field>

                     <Field $col={2} $colMobile={12}>
                        <label>Comprimento</label>
                        <InputWithUnit>
                           <input
                              type="text"
                              name="prod_length"
                              value={newParamList.prod_length || 0}
                              disabled={!editOn}
                              onChange={(e) => {
                                 if (
                                    integerRegex.test(e.target.value) ||
                                    e.target.value === ''
                                 ) {
                                    handleChangeParams(e);
                                 }
                              }}
                           />
                           <span>cm</span>
                        </InputWithUnit>
                     </Field>

                     <Field $col={2} $colMobile={12}>
                        <label>Peso bruto</label>
                        <InputWithUnit>
                           <input
                              type="text"
                              name="prod_weight"
                              value={newParamList.prod_weight || 0}
                              disabled={!editOn}
                              onChange={(e) => {
                                 if (
                                    integerRegex.test(e.target.value) ||
                                    e.target.value === ''
                                 ) {
                                    handleChangeParams(e);
                                 }
                              }}
                           />
                           <span>g</span>
                        </InputWithUnit>
                     </Field>

                     <Field $col={3} $colMobile={12}>
                        <label>Volumetria</label>
                        <InputWithUnit>
                           <input
                              type="text"
                              name="volumetry"
                              value={volumetryValue}
                              disabled
                              readOnly
                           />
                           <span>m³</span>
                        </InputWithUnit>
                     </Field>

                     <Field $col={9} $colMobile={12}>
                        <label>&nbsp;</label>
                        <HelpText>
                           A volumetria é calculada automaticamente ao salvar
                           (Altura × Largura × Comprimento / 100000).
                        </HelpText>
                     </Field>
                  </FormGrid>
               </SectionBody>
            </Section>

            <Section>
               <SectionHeader>
                  <SectionTitle>Fotos</SectionTitle>
               </SectionHeader>
               <SectionBody>
                  <EmptyState>
                     <h4>Sem fotos cadastradas</h4>
                     <p>
                        Em breve: galeria de fotos do produto (imagem principal
                        + adicionais).
                     </p>
                  </EmptyState>
               </SectionBody>
            </Section>

            <Section>
               <SectionHeader>
                  <SectionTitle>Etiquetas</SectionTitle>
               </SectionHeader>
               <SectionBody>
                  <p style={{ marginTop: 0, opacity: 0.9 }}>
                     Gere e imprima etiquetas 10×5 cm para identificação e
                     organização do estoque.
                  </p>

                  <ActionBar>
                     <button
                        type="button"
                        onClick={() => handlePrintLabels(id)}
                        disabled={isCreateMode || !newParamList.prod_sku}
                     >
                        Gerar / imprimir etiquetas
                     </button>
                  </ActionBar>
               </SectionBody>
            </Section>
         </form>
         <Modal
           isOpen={isAuditModalOpen}
           title={`Histórico de Alterações - ${newParamList.prod_name || 'Produto'}`}
           onClose={() => setIsAuditModalOpen(false)}
           footer={
             <button type="button" onClick={() => setIsAuditModalOpen(false)}>
               Fechar
             </button>
           }
           // ✅ Adicione width customizado se quiser modal maior
           style={{ maxWidth: '900px' }}
         >
           <ProductAudit productId={id} />
         </Modal>

         <Modal
            isOpen={isLabelsModalOpen}
            title="Etiqueta 10×5 cm"
            onClose={() => setIsLabelsModalOpen(false)}
            footer={
               <>
                  <button
                     type="button"
                     onClick={() => setIsLabelsModalOpen(false)}
                  >
                     Fechar
                  </button>
                  <button type="button" onClick={handlePrintLabels}>
                     Imprimir etiquetas
                  </button>
               </>
            }
         >
            <FormGrid $cols={12}>
               <Field $col={4} $colMobile={12}>
                  <label>Dt. Ent.</label>
                  <input
                     type="date"
                     value={entryDate}
                     onChange={(e) => setEntryDate(e.target.value)}
                  />
               </Field>

               <Field $col={4} $colMobile={12}>
                  <label>Doc. Ent.</label>
                  <input
                     type="text"
                     placeholder="NF-1234"
                     value={entryDoc}
                     onChange={(e) => setEntryDoc(e.target.value)}
                  />
               </Field>

               <Field $col={4} $colMobile={12}>
                  <label>Quantidade</label>
                  <input
                     type="number"
                     min={1}
                     value={labelQty}
                     onChange={(e) => setLabelQty(e.target.value)}
                  />
               </Field>

               <Field $col={12} $colMobile={12}>
                  <label>Visualização</label>
                  <LabelPreviewCard>
                     <div className="label-top">
                        <span>Dt. Ent.: {entryDate || '--/--/----'}</span>
                        <span>Doc. Ent.: {entryDoc || ''}</span>
                     </div>

                     <div className="label-middle">
                        <div
                           className="barcode"
                           // barcodeMarkup é um SVG serializado (gerado pelo JsBarcode)
                           // eslint-disable-next-line react/no-danger
                           dangerouslySetInnerHTML={{ __html: barcodeMarkup }}
                        />
                        <div className="product-sku">
                           SKU: {buildBarcodeValue(newParamList.prod_sku)}
                        </div>
                        <div className="product-name">
                           {newParamList.prod_name || ''}
                        </div>
                     </div>

                     <div className="label-bottom">
                        <span>{companyName || ''}</span>
                        <span>{companyCnpj || ''}</span>
                     </div>
                  </LabelPreviewCard>
               </Field>
            </FormGrid>
         </Modal>
      </Container>
   );
}
